export * from './generic-hero'
